export const PLANS = {
  ink: '#08081B',
  muted: '#63637D',
  surface: '#F6F6F8',
  cardBg: '#FFFFFF',
  border: 'rgba(8, 8, 27, 0.15)',
  cardShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  font: '"Nunito Sans", "Helvetica", "Arial", sans-serif',
  buttonBg: '#2A2A8B',
  buttonHoverBg: '#22226F',
} as const;
